import { render } from "./CancelIcon.vue?vue&type=template&id=a4efe028&ts=true"
import script from "./CancelIcon.vue?vue&type=script&lang=ts"
export * from "./CancelIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__